import * as gpcActions from "../actions/gpcActions";
import { updateObject } from "../../utils/util";

const initialState = {
    ConsultaMedicoServicio: false,
    imagenes: [],
    linkExpired: false
};

export function gpcReducer(state = initialState, action) {
    switch (action.type) {
        case gpcActions.ADD_CONSULTA:
            return updateObject(state, { ...action.gpc });
        case gpcActions.LINK_EXPIRED:
            return updateObject(state, { ...action.gpc });
        case gpcActions.ADD_IMAGENES:
            return { ...state, ...action.payload }
        case gpcActions.CLEAR_DATA_GPC:
            return initialState;
        default:
            return state;
    }
}
